const Label = ({ text }: any) => {
  return (
    <p className="w-fit bg-gradient-to-r from-blue-500 to-violet-600 px-2 font-oswaldregular text-xs uppercase md:text-sm">
      {text}
    </p>
  )
}

export default Label
